import { 
  collection, 
  doc, 
  addDoc, 
  updateDoc, 
  deleteDoc, 
  getDoc, 
  getDocs, 
  query, 
  where,
  orderBy 
} from 'firebase/firestore';
import { db } from '../config/firebase';

const COLLECTION_NAME = 'companies';

export const companyService = {
  // Create a new company
  async createCompany(companyData) {
    try {
      const docRef = await addDoc(collection(db, COLLECTION_NAME), {
        ...companyData,
        createdAt: new Date(),
        updatedAt: new Date(),
        status: 'active'
      });
      return { id: docRef.id, ...companyData };
    } catch (error) {
      console.error('Error creating company:', error);
      throw error;
    }
  },

  // Get all companies
  async getAllCompanies() {
    try {
      const q = query(
        collection(db, COLLECTION_NAME),
        orderBy('createdAt', 'desc')
      );
      const querySnapshot = await getDocs(q);
      return querySnapshot.docs.map(doc => ({
        id: doc.id,
        ...doc.data()
      }));
    } catch (error) {
      console.error('Error getting companies:', error);
      throw error;
    }
  },

  // Get company by ID
  async getCompanyById(companyId) {
    try {
      const docRef = doc(db, COLLECTION_NAME, companyId);
      const docSnap = await getDoc(docRef);
      
      if (docSnap.exists()) {
        return { id: docSnap.id, ...docSnap.data() };
      } else {
        throw new Error('Company not found');
      }
    } catch (error) {
      console.error('Error getting company:', error);
      throw error;
    }
  },

  // Update company
  async updateCompany(companyId, updateData) {
    try {
      const docRef = doc(db, COLLECTION_NAME, companyId);
      await updateDoc(docRef, {
        ...updateData,
        updatedAt: new Date()
      });
      return { id: companyId, ...updateData };
    } catch (error) {
      console.error('Error updating company:', error);
      throw error;
    }
  },

  // Delete company
  async deleteCompany(companyId) {
    try {
      const docRef = doc(db, COLLECTION_NAME, companyId);
      await deleteDoc(docRef);
      return true;
    } catch (error) {
      console.error('Error deleting company:', error);
      throw error;
    }
  },

  // Get companies by status
  async getCompaniesByStatus(status) {
    try {
      const q = query(
        collection(db, COLLECTION_NAME),
        where('status', '==', status),
        orderBy('createdAt', 'desc')
      );
      const querySnapshot = await getDocs(q);
      return querySnapshot.docs.map(doc => ({
        id: doc.id,
        ...doc.data()
      }));
    } catch (error) {
      console.error('Error getting companies by status:', error);
      throw error;
    }
  }
}; 